import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit'
import { PullRefresh } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { ROUTE_UNIT_CONTROLS } from '@apps-radionet-portal-root/src/config/private-routes'

interface IProps {
  requestHook: any
}

export const UnitControlPage: React.FC<IProps> = ({ requestHook }) => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()

  const { data: unit, isLoading: unitIsLoading, isError: unitIsError } = useGetUnitGenericDetails({ status, unitId })
  const { isLoading, isFetching, isError, data, refetch, onControlStateUpdated } = requestHook({
    config: { enabled: !!unitId },
    unitId: unitId || ''
  })

  return (
    <IonPage>
      <Header>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_UNIT_CONTROLS} />
        <PageTitle>Device Controls</PageTitle>
      </Header>
      <LayoutContainer>
        <PullRefresh loading={isFetching} callback={() => refetch()} />
        <LayoutPadding>
          <div>Controls page</div>
        </LayoutPadding>
      </LayoutContainer>
    </IonPage>
  )
}
